import { render } from "./Navbar.vue?vue&type=template&id=def5c9ca"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/codehat-academy-front-vue3/codehat-academy-front-vue3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__